// extracted by mini-css-extract-plugin
export default {"options":"OptionList--options--7zMaY","title":"OptionList--title--Oo06n","detail":"OptionList--detail--Jessw"};